import React, { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner"
import "../../styles/loader.css";

export default function Loader({ loader_queue_text }) {
    const [showQueueText, setShowQueueText] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowQueueText(true);
        }, 30000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className="loader-overlay">
            {showQueueText && <div className="queue-text">{loader_queue_text}</div>}
            <div className="loader-container">
                <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                />
            </div>
        </div>
    );
}
